import axios from 'axios'
import { API_ENDPOINT } from '../../../config'
import store from '../../../redux/stores/store'
import Validation from '../../../data/validation/validation'
import { StringValidationRule } from '../../../data/validation/rules'

const getDefaultState = (instance) => {
    return {
        saving: false,
        currentPassword: "",
        password: "",
        confirmPassword: "",
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.currentPassword, (error) => errors.currentPassword = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.password, (error) => errors.password = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.confirmPassword, (error) => errors.confirmPassword = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Too long" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    if(instance.state.password !== instance.state.confirmPassword){
        validate = false
        stateUpdate = {
            errors: errors,
            flag: {
                type: "error",
                text: "Confirm password not the same"
            }
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const changePassword = instance => {
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/auth/change-password",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            currentPassword: instance.state.currentPassword,
            password: instance.state.password,
            Authorization: store.getState().auth.authorization
        }
    }).then(response => {
        if (response.status === 200) {
            instance.setState({
                ...getDefaultState(),
                flag: getFlag(response.data)
            })
        }
    }).catch(error => alert(error))
}

const getFlag = response => {
    switch (response.status) {
        case 200:
            return {
                type: "success",
                text: "Password Updated"
            }
        default:
            return {
                type: "error",
                text: response.message
            }
    }
}

const Service = instance => {
    return {
        isValid: () => isValid(instance),
        changePassword: () => changePassword(instance),
        getDefaultState: () => getDefaultState()
    }
}

export default Service